/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelDriverSendMessage.ts             *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/driver-send-message";

export class AutogenModelDriverSendMessage<RowType extends ModelRow> extends Endpoint<RowType, RowDriverSendMessageFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowDriverSendMessage extends ModelRow<RowDriverSendMessageFields> {
	constructor(values?: Partial<RowDriverSendMessageFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowDriverSendMessageFields {
	"driver.ace_id": string;
	"driver.address": string;
	"driver.alert": string;
	"driver.allow_trailer_drop": string;
	"driver.avl_as_of_date": Date;
	"driver.avl_drive_hours": number;
	"driver.avl_hours": number;
	"driver.avl_onduty_hours": number;
	"driver.base_term1": string;
	"driver.base_term2": string;
	"driver.base_zip1": string;
	"driver.base_zip2": string;
	"driver.birth_date": Date;
	"driver.bseg": string;
	"driver.can_rehire": string;
	"driver.capcreat_filter": string;
	"driver.cb": string;
	"driver.cell_phone": string;
	"driver.chain_pref_1": string;
	"driver.chain_pref_1_value": number;
	"driver.chain_pref_2": string;
	"driver.chain_pref_2_value": number;
	"driver.choice_allocation": string;
	"driver.choice_commodity": string;
	"driver.choice_commodity_exclude": string;
	"driver.choice_customer": string;
	"driver.choice_equip_type": string;
	"driver.choice_exclude_hazmat": string;
	"driver.choice_order_type": string;
	"driver.choice_priority1": string;
	"driver.choice_priority1_value": number;
	"driver.choice_priority2": string;
	"driver.choice_priority2_value": number;
	"driver.choice_revenue": string;
	"driver.choice_review_dt": Date;
	"driver.citizen": string;
	"driver.citizen_country": string;
	"driver.city": string;
	"driver.city_id": number;
	"driver.cmove": string;
	"driver.company_id": string;
	"driver.country_hos_rules": string;
	"driver.country_id": string;
	"driver.currenteqpgrpid": string;
	"driver.ded_rqmt_type": string;
	"driver.ded_type": string;
	"driver.disable_driver_choice": string;
	"driver.disable_feasibility": string;
	"driver.disable_remote_access": string;
	"driver.doubles_certified": string;
	"driver.dri_uid": number;
	"driver.drvr_class": string;
	"driver.ds_model_flag": string;
	"driver.eld_exempt_reason_id": string;
	"driver.email": string;
	"driver.emrg_response_date": Date;
	"driver.enable_driver_app": string;
	"driver.enable_load_choice": string;
	"driver.end_status_date": Date;
	"driver.enginedata_pwd": string;
	"driver.equipment_type_id": string;
	"driver.event_date": Date;
	"driver.event_status": string;
	"driver.exclude_allocation": string;
	"driver.exclude_commodity": string;
	"driver.exclude_customer": string;
	"driver.exclude_equip_type": string;
	"driver.exclude_feasibility": string;
	"driver.exclude_order_type": string;
	"driver.exclude_revenue": string;
	"driver.experience": string;
	"driver.first_name": string;
	"driver.fleet_manager": string;
	"driver.fmcsa_clearinghouse_date": Date;
	"driver.group_id": string;
	"driver.hazmat_certified": string;
	"driver.hazmat_date": Date;
	"driver.hire_date": Date;
	"driver.hm126c_date": Date;
	"driver.home_duration": number;
	"driver.home_location_id": string;
	"driver.id": string;
	"driver.is_active": string;
	"driver.last_34_hour_start_date": Date;
	"driver.last_break_date": Date;
	"driver.last_home_date": Date;
	"driver.last_review_date": Date;
	"driver.latitude": number;
	"driver.license_country": string;
	"driver.license_date": Date;
	"driver.license_no": string;
	"driver.license_state": string;
	"driver.logbook_required": string;
	"driver.longitude": number;
	"driver.manual_pta_update": string;
	"driver.maryland_perm_date": Date;
	"driver.max_dispatches": number;
	"driver.max_dist_loc1": number;
	"driver.max_dist_loc2": number;
	"driver.max_mi_per_day": number;
	"driver.mc_login": string;
	"driver.mc_unit_password": string;
	"driver.medical_cert_exempt": string;
	"driver.medical_cert_expire": Date;
	"driver.model_flag": string;
	"driver.mpw_driver_contact_method": string;
	"driver.mpw_driver_high": number;
	"driver.mpw_driver_low": number;
	"driver.mpw_exclude": string;
	"driver.mpw_last_contact": Date;
	"driver.mpw_num_attempts": number;
	"driver.mpw_num_orders": number;
	"driver.mvr_date": Date;
	"driver.name": string;
	"driver.name_mid_initial": string;
	"driver.name_of_spouse": string;
	"driver.next_home_date": Date;
	"driver.num_complaints": number;
	"driver.pager": string;
	"driver.passport": string;
	"driver.payee_id": string;
	"driver.personal_conveyance": string;
	"driver.phone": string;
	"driver.physical_date": Date;
	"driver.planning_comment": string;
	"driver.preferred_days_out": number;
	"driver.prev_code": string;
	"driver.primary_agency": string;
	"driver.proximity_card": string;
	"driver.pta_date": Date;
	"driver.race": string;
	"driver.reason_for_leaving": string;
	"driver.record_pta": string;
	"driver.remark": string;
	"driver.reporting_status": string;
	"driver.return_home_flag": string;
	"driver.route_through_term": string;
	"driver.safety_meet_date": Date;
	"driver.safety_topic": string;
	"driver.security_date": Date;
	"driver.sex": string;
	"driver.shuttle_capable": string;
	"driver.site_id": string;
	"driver.social_security_no": string;
	"driver.speed": number;
	"driver.start_status_date": Date;
	"driver.state": string;
	"driver.status_code": string;
	"driver.stop_pta_update": string;
	"driver.tanks_endorsement": string;
	"driver.team_status": string;
	"driver.tenstreet_id": string;
	"driver.termination_date": Date;
	"driver.tractor_id": string;
	"driver.trainee": string;
	"driver.type_of": string;
	"driver.violation_comment": string;
	"driver.yard_move": string;
	"driver.zip": string;
	driver_name: string;
	email: string;
}

